import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not found. Please add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your .env.local file');
}

// Create Supabase client with api schema (Supabase default)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
  db: {
    schema: 'api'
  },
  global: {
    headers: {
      'Content-Type': 'application/json',
      'Prefer': 'return=representation'
    }
  }
});

// Database Types
export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  search_query: string;
  content: string;
  excerpt: string;
  cover_image?: string;
  images?: string[];
  image_captions?: string[];
  laptops_mentioned: string[];
  created_at: string;
  updated_at: string;
  view_count: number;
  published: boolean;
}

export interface SearchLog {
  id: string;
  search_query: string;
  normalized_query: string;
  result_count: number;
  blog_post_id: string | null;
  created_at: string;
}
